import React, { useState } from 'react'
import { useLogs } from '../hooks/useApi'
import type { CommandType, LogResponse } from '../types/api'

export default function LogsList() {
  const [commandFilter, setCommandFilter] = useState<CommandType | ''>('')
  const [filteredLogs, setFilteredLogs] = useState<LogResponse[]>([])
  const { data: logs, loading, error, refetch } = useLogs()

  // Filter logs by command when filter changes
  React.useEffect(() => {
    if (!logs) {
      setFilteredLogs([])
      return
    }

    if (!commandFilter) {
      setFilteredLogs(logs)
      return
    }

    setFilteredLogs(logs.filter(log => log.command === commandFilter))
  }, [logs, commandFilter])

  const handleRefresh = () => {
    refetch()
  }

  const handleCommandFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCommandFilter(e.target.value as CommandType | '')
  }

  if (loading) {
    return (
      <div className="list-group">
        {Array.from({ length: 5 }, (_, i) => `skeleton-log-${Date.now()}-${i}`).map(key => (
          <div key={key} className="list-group-item">
            <div className="placeholder-glow">
              <span className="placeholder col-6" />
              <span className="placeholder col-8" />
              <span className="placeholder col-4" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        ログ読み込みエラー: {error}
      </div>
    )
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>
          <i className="fas fa-list me-2" />最近のログ
        </h5>
        <div className="d-flex gap-2">
          <select
            className="form-select form-select-sm"
            style={{ width: 'auto' }}
            value={commandFilter}
            onChange={handleCommandFilterChange}
          >
            <option value="">全コマンド</option>
            <option value="+MGST">+MGST</option>
            <option value="+PLAY">+PLAY</option>
            <option value="+SC">+SC</option>
            <option value="+EM">+EM</option>
            <option value="+PLAYSC">+PLAYSC</option>
          </select>
          <button type="button" className="btn btn-primary btn-sm" onClick={handleRefresh}>
            <i className="fas fa-sync-alt me-1" />
            更新
          </button>
        </div>
      </div>
      <div className="list-group">
        {filteredLogs?.map(log => (
          <div
            key={log.id}
            className={`list-group-item log-item ${log.is_error ? 'log-error' : ''}`}
          >
            <div className="d-flex justify-content-between align-items-start">
              <div className="flex-grow-1">
                <div className="d-flex align-items-center mb-1">
                  <strong className="me-2">{log.mago_id}</strong>
                  {log.command && (
                    <span className="badge bg-secondary command-badge me-2">{log.command}</span>
                  )}
                  {log.is_error && <span className="badge bg-danger">エラー</span>}
                </div>
                <div className="text-muted mb-1">
                  <small>
                    <i className="fas fa-satellite-dish me-1" />
                    {log.endpoint} | {log.topic}
                  </small>
                </div>
                <div className="mb-1">
                  <code className="text-dark">{log.raw_data}</code>
                </div>
                {log.device_info && (
                  <div className="text-muted">
                    <small>
                      <i className="fas fa-info-circle me-1" />
                      端末情報: {log.device_info}
                    </small>
                  </div>
                )}
              </div>
              <div className="text-end">
                <small className="log-timestamp">{new Date(log.entry_dt).toLocaleString()}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
